import { Injectable } from '@angular/core';
import { WindowsService } from '@smarsh-cyber/shared/services';

@Injectable({ providedIn: 'root' })
export class StateStorageService {
  constructor(private windowsService: WindowsService) { }

  getPreviousState() {
    return JSON.parse(
      this.windowsService.getFromSessionStorage('previousState')
    );
  }

  resetPreviousState() {
    this.windowsService.removeFromSessionStorage('previousState');
  }

  storePreviousState(previousStateName, previousStateParams) {
    const previousState = {
      name: previousStateName,
      params: previousStateParams
    };
    this.windowsService.setToSessionStorage(
      'previousState',
      JSON.stringify(previousState)
    );
  }

  storeUrl(url: string) {
    this.windowsService.setToSessionStorage('previousUrl', url);
  }

  getUrl() {
    return this.windowsService.getFromSessionStorage('previousUrl');
  }

  storeServiceData(serviceName: string, serviceData: any): any {
    this.windowsService.setToSessionStorage(
      serviceName,
      JSON.stringify(serviceData)
    );
  }

  getServiceData(serviceName: string) {
    return JSON.parse(this.windowsService.getFromSessionStorage(serviceName));
  }

  storeCurrentUserData(serviceName: string, serviceData: any): any {
    this.windowsService.setToSessionStorage(
      serviceName,
      JSON.stringify(serviceData)
    );
  }

  getCurrentUserData(serviceName: string) {
    return JSON.parse(this.windowsService.getFromSessionStorage(serviceName));
  }

  storeOriginPortal(serviceName: string, serviceData: any): any {
    this.windowsService.setToSessionStorage(
      serviceName,
      JSON.stringify(serviceData)
    );
  }

  getOriginPortal(serviceName: string) {
    return JSON.parse(this.windowsService.getFromSessionStorage(serviceName));
  }

  clearSessionStorage() {
    return this.windowsService.clearSessionStorage();
  }

  storeRefreshToken(jwt, rememberMe) {
    if (rememberMe) {
      this.windowsService.setToLocalStorage('refreshToken', jwt);
    } else {
      this.windowsService.setToSessionStorage('refreshToken', jwt);
    }
  }

  setToken(accessToken, refreshToken) {
    if (this.windowsService.getFromLocalStorage('authenticationToken')) {
      this.windowsService.setToLocalStorage('authenticationToken', accessToken);
      this.windowsService.setToLocalStorage('refreshtoken', refreshToken);
    } else {
      this.windowsService.setToSessionStorage(
        'authenticationToken',
        accessToken
      );
      this.windowsService.setToSessionStorage('refreshtoken', refreshToken);
    }
  }

  removeToken() {
    if (this.windowsService.getFromLocalStorage('authenticationToken')) {
      this.windowsService.removeFromLocalStorage('authenticationToken');
    } else {
      this.windowsService.removeFromSessionStorage('authenticationToken');
    }
  }

  getRefreshToken() {
    return (
      this.windowsService.getFromLocalStorage('refreshtoken') ||
      this.windowsService.getFromSessionStorage('refreshtoken')
    );
  }
}
